export default "__VITE_ASSET__DKcCgFWQ__"